import {Component, Input, Output, EventEmitter} from '@angular/core';
import {NavController, NavParams} from "ionic-angular";
import moment from 'moment';

@Component({
  selector: 'shop-about',
  templateUrl: 'shop-about.html'
})
export class ShopAboutComponent {

  @Input() shop: any;
  @Input() showOurTeam: boolean;
  @Input() shopType: 'coffeShop' | 'barberShop';
  @Output() selectHoursEvent = new EventEmitter();
  errors: {};
  loading: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
    this.shop = navParams.get('shop');
    this.loading = true;
  }

  openingTime(shop) {
    if (!shop.closed) {
      return this.formatTime(shop.open_at) + ' - ' + this.formatTime(shop.close_at);
    }

    return 'Closed';
  }

  formatTime(time) {
    return moment(time, 'HH:mm:ss').format('h:mma');
  }
  public selectHoursComponentEvent(event): void {
    this.selectHoursEvent.emit(event);
  }

  ngOnChanges(changes) {
    if (changes.shop) {
      this.shop = changes.shop.currentValue;
      if (this.shop.users) {
        this.loading = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/shop-about/shop-about.ts